var _circle, _path, _ellipse, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse2, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _circle2, _circle3, _circle4, _circle5, _path47, _rect, _rect2, _rect3, _rect4, _circle6, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginIlustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 606,
    height: 517,
    viewBox: "0 0 606 517",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 489.056,
    cy: 138.478,
    r: 41.3286,
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25238
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26175 290.643C-0.25064 258.081 12.6433 231.781 16.9074 212.995C40.0764 110.926 207.269 -3.66716 299.946 0.0899863C392.622 3.84714 482.794 84.6259 509.72 184.817C536.646 285.007 489.682 376.431 479.663 407.115C469.644 437.798 403.267 488.519 366.322 500.417C329.377 512.315 269.262 499.791 251.729 492.903C234.196 486.015 217.288 467.229 199.129 419.638C180.969 372.048 80.7787 343.243 68.8811 340.738C56.9834 338.233 14.4022 331.345 6.26175 290.643Z",
    fill: "#FF7F66"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 434.981,
    cy: 387.703,
    rx: 20.2868,
    ry: 179.894,
    transform: "rotate(64.0255 434.981 387.703)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356.303 325.083L125.864 454.705L63.8715 430.91V397.722L408.277 207.986L420.175 283.129L356.303 325.083Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2739 404.61L403.267 222.388",
    stroke: "black",
    strokeWidth: 1.25238
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.583 417.134L410.782 246.81",
    stroke: "black",
    strokeWidth: 1.25238
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.238 424.022L410.782 262.464",
    stroke: "black",
    strokeWidth: 1.25238
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M309.339 155.386C316.227 155.386 321.862 149.75 321.862 142.862C321.862 135.974 316.227 130.338 309.339 130.338C302.45 130.338 296.815 135.974 296.815 142.862C296.815 149.75 302.45 155.386 309.339 155.386Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M304.016 142.862L307.56 146.406L314.661 139.318",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M376.967 64.7965C385.003 64.7965 391.578 58.2215 391.578 50.1854C391.578 42.1492 385.003 35.5742 376.967 35.5742C368.931 35.5742 362.356 42.1492 362.356 50.1854C362.356 58.2215 368.931 64.7965 376.967 64.7965Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M370.758 50.1854L374.892 54.3203L383.177 46.0504",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M458.372 98.1934C471 98.1934 481.333 87.8613 481.333 75.2331C481.333 62.6049 471 52.2727 458.372 52.2727C445.744 52.2727 435.412 62.6049 435.412 75.2331C435.412 87.8613 445.744 98.1934 458.372 98.1934Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M448.614 75.2331L455.112 81.7309L468.13 68.7354",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M296.815 216.752L324.367 258.707L342.527 245.557L316.853 203.602L296.815 216.752Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M324.993 266.22L309.965 274.36C313.722 291.892 333.134 325.71 343.153 340.738C351.168 352.761 359.851 354.097 363.191 353.262L354.424 430.284L521.618 345.746C526.627 239.295 473.401 181.058 442.091 174.796C441.048 175.631 438.71 177.426 437.708 177.927C436.455 178.553 430.194 180.432 427.689 181.058C425.184 181.684 422.053 182.31 418.296 184.815C415.29 186.819 412.451 191.077 411.408 192.955C411.408 192.955 378.22 302.539 373.836 306.296C370.33 309.302 339.813 280.831 324.993 266.22Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M411.408 192.955C411.408 192.955 378.22 302.539 373.836 306.296C370.33 309.302 339.813 280.831 324.993 266.22L309.965 274.36C313.722 291.892 333.134 325.71 343.153 340.738C351.168 352.761 359.851 354.097 363.191 353.262L354.424 430.284L521.618 345.746C526.627 239.295 473.401 181.058 442.091 174.796C441.048 175.631 438.71 177.426 437.708 177.927C436.455 178.553 430.194 180.432 427.689 181.058C425.184 181.684 422.053 182.31 418.296 184.815C415.29 186.819 412.451 191.077 411.408 192.955ZM411.408 192.955C421.844 195.461 443.873 201.097 453.989 229.276C460.957 248.688 465.886 273.11 457.746 298.783C449.416 325.054 431.139 352.096 398.884 370.795C373.52 385.5 372.02 386.5 370.079 387.703",
    stroke: "#121212",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M319.674 245.548L325.587 241.8",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M321.07 247.109L325.136 244.613",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M458.372 241.8C466.513 239.713 484.046 231.906 491.56 217.379",
    stroke: "#FF7F66",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M460.877 251.193C469.017 249.106 489.056 238.794 496.57 224.267",
    stroke: "#FF7F66",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M369.453 154.759C369.453 151.253 366.531 144.532 365.07 141.609L397.005 131.59L420.174 147.245C422.178 154.258 435.621 168.536 442.091 174.798C442.3 174.798 442.091 175.299 439.586 177.302C436.455 179.807 431.446 180.433 423.305 182.312C416.793 183.815 412.66 190.452 411.408 193.583L399.51 168.536C397.423 169.371 391.871 171.04 386.36 171.04C380.85 171.04 376.55 165.613 375.089 162.9L366.948 162.274C367.783 161.23 369.453 158.266 369.453 154.759Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M369.453 144.74C370.497 143.697 373.085 142.236 375.089 144.74",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M397.005 142.235C398.675 141.192 402.265 140.357 403.267 145.366",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M391.37 142.862C387.863 141.86 380.724 139.522 377.593 138.478L416.417 124.702C417.044 128.042 418.672 135.473 420.174 138.478C422.053 142.235 426.436 142.862 424.558 145.366C422.679 147.871 412.66 147.245 409.529 146.619C406.398 145.993 405.772 140.983 401.389 138.478C397.882 136.474 395.336 138.478 394.501 139.731C394.918 141.192 394.876 143.864 391.37 142.862Z",
    fill: "#1F1F1F",
    stroke: "#040404",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M357.546 133.481L357.555 133.469C356.72 129.085 356.804 118.19 363.817 109.674C372.584 99.0283 381.977 97.7759 397.005 101.533C399.297 102.106 401.382 103.052 403.267 104.251C411.277 109.344 415.692 119.007 417.044 124.076C410.584 126.542 399.817 130.594 390.117 134.113C382.577 136.848 375.682 139.261 371.958 140.357C363.442 142.862 354.216 142.653 350.667 142.236L357.546 133.481Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M357.555 133.469L350.667 142.236C354.216 142.653 363.442 142.862 371.958 140.357C375.682 139.261 382.577 136.848 390.117 134.113M357.555 133.469C356.72 129.085 356.804 118.19 363.817 109.674C372.584 99.0283 381.977 97.7759 397.005 101.533C399.297 102.106 401.382 103.052 403.267 104.251M357.555 133.469C356.578 134.691 361.522 135.071 368.201 135.044M390.117 134.113C399.817 130.594 410.584 126.542 417.044 124.076C415.692 119.007 411.277 109.344 403.267 104.251M390.117 134.113C384.131 134.538 375.211 135.015 368.201 135.044M368.201 135.044C366.948 126.796 367.199 109.423 378.22 105.916C382.812 103.554 394.25 99.9124 403.267 104.251",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M173.455 244.931L190.362 238.669L192.241 247.436L185.353 248.688L190.362 271.231L173.455 244.931Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M221.672 244.931L204.765 238.669L202.886 247.436L209.774 248.688L204.765 271.231L221.672 244.931Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.857 135.974L201.007 149.75L190.362 167.909L201.634 180.433L191.615 194.209L201.634 204.855L193.493 214.248L201.634 223.014L194.119 233.033",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M201.007 134.721L189.11 149.75L201.037 167.283L190.899 181.059L201.037 193.583L192.867 204.855L201.634 214.874L193.493 223.64L201.634 233.033",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M194.119 233.033L187.857 133.469L201.007 132.216L202.26 233.033H194.119Z",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 55.175,
    cy: 153.686,
    rx: 23.0386,
    ry: 116.787,
    transform: "rotate(16.4543 55.175 153.686)",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2072 135.974L166.567 105.916",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6738 205.481L175.334 126.581",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7025 142.236L77.6478 177.928L105.2 121.571L142.772 143.488L153.417 109.674L175.334 126.581",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8047 204.229L72.012 129.086L113.341 159.143L130.248 115.309L160.931 134.095L169.072 118.44",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9738 115.936C43.4159 129.503 25.5486 174.046 22.5428 243.679",
    stroke: "white",
    strokeWidth: 1.25238,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7882 52.6901C87.8755 51.6465 91.424 57.9501 88.9192 91.514",
    stroke: "white",
    strokeWidth: 1.25238,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M42.581 137.226L167.193 106.543",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6738 206.107L175.96 127.207",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3095 202.976L73.2644 129.712",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2739 177.928L105.826 122.197",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M113.967 159.769L130.874 115.936",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M143.398 144.74L154.043 110.3",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M161.557 134.721L170.324 117.814",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.511 143.627L54.6702 157.126",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2644 130.338L92.6763 144.74",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9834 158.516L77.6477 178.555",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5549 145.993L113.341 159.769",
    stroke: "white",
    strokeWidth: 0.626192,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.241,
    cy: 107.169,
    r: 26.3,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.503,
    cy: 241.174,
    r: 8.76668,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.25238
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.241,
    cy: 107.169,
    r: 18.7857,
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25238
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 198.503,
    cy: 241.174,
    r: 5.00953,
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25238
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125 424.308L64 398V430.571L125 455V424.308Z",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 190.362,
    y: 263.091,
    width: 15.0286,
    height: 48.8429,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.948,
    y: 350.757,
    width: 15.0286,
    height: 48.8429,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160.305,
    y: 324.457,
    width: 15.0286,
    height: 48.8429,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 250.477,
    y: 275.614,
    width: 15.0286,
    height: 48.8429,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 373.836,
    cy: 149.75,
    r: 1.87857,
    fill: "#1E1E1E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M390.743 155.385L383.855 164.778C385.525 165.405 389.241 166.156 390.743 164.152C392.246 162.148 391.37 157.473 390.743 155.385Z",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M409.529 163.526L399.51 168.536L410.782 192.331L409.529 163.526Z",
    fill: "#070707",
    stroke: "#121212",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M363.191 353.262C370.914 353.053 387.738 351.884 393.248 348.879C400.136 345.122 426.436 324.457 431.446 314.438C436.4 304.53 452.377 274.414 452.73 270.114C452.733 270.068 452.735 270.023 452.736 269.979C452.736 270.02 452.734 270.065 452.73 270.114C452.078 284.584 446.927 317.117 431.446 332.598C412.034 352.01 410.782 355.767 397.632 363.281C384.482 370.795 380.098 372.674 371.332 372.674H361.312L363.191 353.262Z",
    fill: "black",
    stroke: "#121212",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M385.108 277.493C385.316 289.599 385.358 314.188 383.855 315.691C382.414 317.132 373.174 309.085 368.186 304.374C367.959 304.168 367.753 303.971 367.574 303.793C367.77 303.98 367.974 304.174 368.186 304.374C369.815 305.852 372.517 307.803 373.836 306.924C375.339 305.922 381.977 286.886 385.108 277.493Z",
    fill: "black",
    stroke: "#121212",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M313.096 272.483C311.635 270.605 308.712 265.595 308.712 260.586V234.912L313.096 244.305C314.348 242.635 317.354 239.546 319.358 240.548C321.862 241.8 320.61 246.81 319.358 249.314C318.545 250.939 320.368 252.329 321.236 254.324C321.335 254.552 321.422 254.811 321.491 255.088L321.862 256.202L321.645 256.856C321.6 257.332 321.473 257.766 321.236 258.081L320.61 261.838L323.115 266.848L313.096 272.483Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M321.236 258.081C319.733 260.085 318.105 261.838 317.479 262.464M321.236 258.081C321.896 257.201 321.706 255.404 321.236 254.324M321.236 258.081L320.61 261.838L323.115 266.848L313.096 272.483C311.635 270.605 308.712 265.595 308.712 260.586C308.712 255.576 308.712 241.383 308.712 234.912L313.096 244.305C314.348 242.635 317.354 239.546 319.358 240.548C321.862 241.8 320.61 246.81 319.358 249.314C318.545 250.939 320.368 252.329 321.236 254.324M321.236 258.081L321.862 256.202L321.236 254.324",
    stroke: "black",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M319.384 220.413C321.106 219.278 321.587 216.94 320.452 215.218C319.318 213.495 316.98 213.014 315.257 214.149C313.535 215.284 313.054 217.622 314.189 219.344C315.323 221.067 317.661 221.548 319.384 220.413Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.626192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M315.99 218.158L317.46 218.46L318.068 215.518",
    stroke: "black",
    strokeWidth: 0.626192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M326.403 231.128C328.125 229.993 328.606 227.655 327.471 225.933C326.337 224.21 323.999 223.729 322.276 224.864C320.554 225.999 320.073 228.337 321.208 230.059C322.342 231.782 324.68 232.263 326.403 231.128Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.626192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M323.008 228.873L324.479 229.175L325.087 226.233",
    stroke: "black",
    strokeWidth: 0.626192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M333.917 243.652C335.64 242.517 336.121 240.179 334.986 238.457C333.851 236.734 331.513 236.253 329.791 237.388C328.068 238.523 327.587 240.861 328.722 242.583C329.857 244.306 332.195 244.787 333.917 243.652Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.626192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M330.523 241.397L331.993 241.699L332.601 238.757",
    stroke: "black",
    strokeWidth: 0.626192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M304.503 222.697L310.416 218.948",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M312.16 234.277L318.073 230.528",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M305.899 224.258L309.965 221.762",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M313.556 235.838L317.622 233.342",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M195.998 455.331C200.799 473.908 227.308 512.064 294.936 516.072",
    stroke: "#070707",
    strokeWidth: 1.25238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIlustration);
export default __webpack_public_path__ + "static/media/login-ilustration.9a1c4a8a.svg";
export { ForwardRef as ReactComponent };